import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'

i18n
  .use(Backend)
  .use(initReactI18next) 
  .use(LanguageDetector)
  .init({
    lng: navigator.language || 'en',
    fallbackLng: 'en', 
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locals/{{lng}}/translation.json',
       prefix: 'knowledgeImpact:'
    },
    detection: {
        order: ['localStorage'],
        caches: ['localStorage'],
        lookupLocalStorage: 'lang',
      },
      
  })

  
  const storedLanguage = localStorage.getItem('lang')
    if (storedLanguage) {
        i18n.changeLanguage(storedLanguage)
    }

export default i18n
